import type { Repository } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { PageContent } from "~/components/PageContent/PageContent";
interface PhBranchVariablesPageProps {
    loaderData: LoaderData;
}
interface PhBranchVariablesPageQueryParams {
}
interface LoaderData {
}
export async function phBranchVariablesPageLoader(repository: Repository, { routeParams, queryParams }: {
    routeParams: {
        slug: string;
        gitRef: string;
    };
    queryParams: PhBranchVariablesPageQueryParams;
}): Promise<LoaderData> {
    // TODO: Implement proper loader
    return {};
}
export function PhBranchVariablesPage({ loaderData }: PhBranchVariablesPageProps) {
    return (<PageContent header={{ title: "Project Template Variables" }}>
            <div>
                <h1>Project Template Variables</h1>
                <p>This page is a placeholder for the project template variables page.</p>
            </div>
        </PageContent>);
}
